export default __webpack_public_path__ + "static/media/woonkamer.dc63bd74.jpg";